export default __webpack_public_path__ + "static/media/serviceX2.d2ade32c.jpg";